module.exports = __webpack_public_path__ + "img/orange_037.685b667a.png";